import domain from './domain';

// Reset task time tracking entires
export const resetTaskTimeTrackingEntries = domain.createEvent('resetTaskTimeTrackingEntries');
